export const colors = {
  // Primary: dusty mauve/purple ramp from the image
  primary:         '#634776',   // solid purple from image
  primaryHover:    '#523664',   // darker solid purple
  primaryDark:     '#442855',   // darkest solid purple
  primaryLight:    '#BB9CD1',   // lighter interactive purple
  primaryBg:       '#F5EEFA',   // lightest bg purple
  primaryBgHover:  '#EEE3F7',   // slightly deeper bg purple

  // Neutral backgrounds from the gray row
  bg:              '#F7FAFB',   // lightest gray bg
  card:            '#ffffff',
  border:          '#DCE2E6',   // gray border from image
  borderLight:     '#EEE3F7',   // soft purple border
  text:            '#1C2024',   // darkest accessible gray-text
  textMuted:       '#5D656C',   // solid gray from image
  textLight:       '#868F97',   // muted gray from image

  // Success — using teal-green tone
  success:         '#1a6648',
  successBg:       '#e4f4ec',
  successBorder:   '#b3dcc8',

  // Warning — amber warm
  warning:         '#8a4e0e',
  warningBg:       '#fef3e2',
  warningBorder:   '#f5d49a',

  // Danger — keeping red semantic
  danger:          '#8c2020',
  dangerBg:        '#fce8e8',
  dangerBorder:    '#f5b8b8',

  // Info
  info:            '#1e40af',
  infoBg:          '#dbeafe',
} as const;

export type AttendanceStatus = 'present' | 'absent' | 'late' | null;

export const statusColors: Record<NonNullable<AttendanceStatus>, { bg: string; border: string; text: string; dot: string }> = {
  present: { bg: colors.successBg, border: colors.successBorder, text: colors.success,  dot: '#22a06b' },
  absent:  { bg: colors.dangerBg,  border: colors.dangerBorder,  text: colors.danger,   dot: '#e04444' },
  late:    { bg: '#fef9c3',        border: '#facc15',             text: '#854d0e',        dot: '#eab308' },
};